import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import Modal from "components/Modals/Modal";
import Report from "components/Report/Report";

const ModalStyled = styled(Modal)({
  "& .wrapper": {
    width: "calc(100vw - 150px)",
    height: "calc(100vh - 100px)",
  },
});

const ReportsModal = ({ isOpen, onClose, taxNumber, years }) => {
  const { t } = useTranslation();

  return (
    <ModalStyled
      isOpen={isOpen}
      onClose={onClose}
      title={t("KydTable.ReportsTitle")}
    >
      <Report taxNumber={taxNumber} isShown={isOpen} applicationYears={years} />
    </ModalStyled>
  );
};
export default ReportsModal;
